import { useLayoutEffect, useState } from "react";
import { syncClientSelectionState } from "../utils/resultsFleetData.js";
import {
  buildResultsState,
  collectRouteTargetElements,
  createPlanningDiagnosticsRecorder,
  resolveMostOccupiedAssignmentEntry,
} from "../utils/resultsWorkspaceData.js";

function syncInitialWorkspaceSelection({ setWorkspaceSelectionState, state, syncWorkspaceUi }) {
  if (!state.assignmentList.length) {
    syncClientSelectionState(state);
    syncWorkspaceUi({ assignment: null, trip: null });
    return;
  }

  const mostOccupiedAssignmentEntry = resolveMostOccupiedAssignmentEntry(state.assignmentList);
  if (mostOccupiedAssignmentEntry) {
    setWorkspaceSelectionState(state, mostOccupiedAssignmentEntry.assignment, mostOccupiedAssignmentEntry.trip, null);
    syncWorkspaceUi({
      assignment: mostOccupiedAssignmentEntry.assignment,
      trip: mostOccupiedAssignmentEntry.trip,
    });
    return;
  }

  const firstTripEntry = state.firstTripEntry;
  if (firstTripEntry) {
    setWorkspaceSelectionState(state, firstTripEntry.assignment, firstTripEntry.trip, null);
    syncWorkspaceUi({
      assignment: firstTripEntry.assignment,
      trip: firstTripEntry.trip,
    });
    return;
  }

  const firstAssignment = state.assignmentList[0] || null;
  if (firstAssignment) {
    setWorkspaceSelectionState(state, firstAssignment, null, null);
    syncWorkspaceUi({ assignment: firstAssignment, trip: null });
    return;
  }

  syncClientSelectionState(state);
  syncWorkspaceUi({ assignment: null, trip: null });
}

function readWorkspaceElements() {
  if (typeof document === "undefined") {
    return null;
  }

  return collectRouteTargetElements();
}

export default function useResultsWorkspaceBootstrap({
  detailViewState,
  initialResultsData = null,
  resetMapRenderMeta,
  setWorkspaceSelectionState,
  syncWorkspaceUi,
  workspaceStore,
}) {
  const [workspaceElements, setWorkspaceElements] = useState(() => readWorkspaceElements());

  useLayoutEffect(() => {
    if (!detailViewState.ready) {
      return undefined;
    }

    setWorkspaceElements(readWorkspaceElements());
    return undefined;
  }, [detailViewState.activeView, detailViewState.ready]);

  useLayoutEffect(() => {
    if (!initialResultsData || !detailViewState.ready) {
      return undefined;
    }

    const elements = readWorkspaceElements();
    const state = buildResultsState(initialResultsData, {
      previousState: workspaceStore.getState(),
    });

    state.planningDiagnostics = createPlanningDiagnosticsRecorder() || null;
    state.detailViews = detailViewState.detailViews;
    state.renderFleetColumn = () => {
      syncWorkspaceUi();
    };

    setWorkspaceElements(elements);
    workspaceStore.setState(state);
    resetMapRenderMeta(state);
    syncInitialWorkspaceSelection({
      setWorkspaceSelectionState,
      state,
      syncWorkspaceUi,
    });

    return undefined;
  }, [detailViewState.detailViews, detailViewState.ready, initialResultsData]);

  return {
    workspaceElements,
  };
}
